export const orgSettingsEndpoints = {
  getEnabledFeatureFlags: { method: 'get', path: '/feature-flags' },
  toggleFeatureFlag: { method: 'post', path: '/feature-flags/toggle/{id}' },
  getOrganisationSettings: { method: 'get', path: '/organisation' },
  getOrganisationSettingsByOrganisationId: { method: 'get', path: '/organisation/{organisationId}' },
  updateOrganisationSetting: { method: 'post', path: '/organisation/update' },
  updateOrganisationQAStatus: { method: 'post', path: '/organisation-qa-status/update' },
  addOrganisationExternalDomain: { method: 'post', path: '/external-domain/add' },
  deleteOrganisationExternalDomain: { method: 'post', path: '/external-domain/delete' },
  updateOrganisationName: { method: 'post', path: '/organisation-name/update' },
  getOrganisationDetail: { method: 'get', path: '/organisation-detail' },
  getOrganisationLocales: { method: 'get', path: '/locales' },
  addOrganisationLocale: { method: 'post', path: '/locales/add' },
  createTableFilter: { method: 'post', path: '/table-filters' },
  updateTableFilter: { method: 'post', path: '/table-filters/{id}/update' },
  deleteTableFilter: { method: 'post', path: '/table-filters/{id}/delete' },
  toggleTableFilterFavourite: { method: 'post', path: '/table-filters/{id}/favourite' },
  getTableFiltersByFilter: { method: 'get', path: '/table-filters' },
  getExternalAuditLogArchives: { method: 'get', path: '/external-audit-log-archives' },
  createExternalAuditLogArchive: { method: 'post', path: '/external-audit-log-archives' },
  updateExternalAuditLogArchive: { method: 'post', path: '/external-audit-log-archives/{id}/update' },
  deleteExternalAuditLogArchive: { method: 'post', path: '/external-audit-log-archives/{id}/delete' },
} as const
